import React from 'react';
import { LICENSE_STATUS, LICENSE_STATUS_COLOR } from '../../constants/license';
import { Error, WarningOutlined } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import translations from '../../translations/i18next';
import moment from 'moment';

const LicenseIconStatus = (props) => {
  switch (props.licenseStatus) {
    case LICENSE_STATUS.EXPIRED:
      return (
        <Tooltip
          title={translations.t(`licenseTooltip.${LICENSE_STATUS.EXPIRED}`, {
            formattedDate: moment(props.license.endDate).format('LLL')
          })}
          arrow
          placement="bottom"
        >
          <Error style={{ color: LICENSE_STATUS_COLOR[LICENSE_STATUS.EXPIRED] }} fontSize="small" />
        </Tooltip>
      );

    case LICENSE_STATUS.WARNING:
      return (
        <Tooltip
          title={translations.t(`licenseTooltip.${LICENSE_STATUS.WARNING}`, {
            formattedDate: moment(props.license.endDate).format('LLL')
          })}
          arrow
          placement="bottom"
        >
          <WarningOutlined style={{ color: LICENSE_STATUS_COLOR[LICENSE_STATUS.WARNING] }} fontSize="small" />
        </Tooltip>
      );
    default:
      return null;
  }
};

export default LicenseIconStatus;
